import sidebar from '@/config/sidebars/adminSettings'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminSettingsOperationStates = {
  index: async(props) => {
    const { default: OperationStatesIndex } = await import('@/vue_widgets/admin/settings/operation_states/index.vue')
    createVueApp(OperationStatesIndex, { props, sidebar })
  }
}

Styxie.Initializers.AdminSettingsOnboardingFlows = {
  index: async(props) => {
    const { default: OnboardingIndex } = await import('@/vue_widgets/admin/settings/onboarding/index/index.vue')
    createVueApp(OnboardingIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: OnboardingShow } = await import('@/vue_widgets/admin/settings/onboarding/show/index.vue')
    createVueApp(OnboardingShow, { props, sidebar })
  }
}

Styxie.Initializers.AdminSettingsSystemUsers = {
  index: async(props) => {
    const { default: SystemUsersIndex } = await import('@/vue_widgets/admin/settings/system_users/index/index.vue')
    createVueApp(SystemUsersIndex, { props, sidebar })
  }
}
